import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { UtilService } from './util-service';
import { GestaoPcaService } from './gestao-pca-service';
import { saveAs } from 'file-saver';

import { Observable } from 'rxjs';
import { FileService } from "./file-service";

@Injectable()
export class ConvenioService {
    urlObterQuestoes: string;
    codigoModuloConvenio = 6;
    analiseAtual: any = null;
    idPaginaConvenio: string = "956";
    resumoAnalise: any;
    TIPO_ARQUIVO_CONVENIO = 6;

    constructor(public http: HttpClient,
        private gestaoPcaService: GestaoPcaService,
        private utilService: UtilService,
        private fileService: FileService) {
    }

    public obterIdPaginaConvenio() {
        return this.idPaginaConvenio;
    }

    public obterListaAnalises(codModulo): Observable<any> {
        this.urlObterQuestoes = "convenios?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.getJSON(this.urlObterQuestoes);
    }

    public salvarAnalisePecasConvenio(pcdAnalise, jsonObjeto): Observable<any> {
        this.urlObterQuestoes = "convenios/salvarAnalisesPecasObrigatorias?idPca=" + this.gestaoPcaService.getPCA().id + "&cdAnalise=" + pcdAnalise;
        return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
    }

    public submeterModuloConvenio(jsonObjeto): Observable<any> {
        this.urlObterQuestoes = "convenios/submeterModulo?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
    }

    public finalizarAnalisePecasConvenio(pcdAnalise, jsonObjeto): Observable<any> {
        this.urlObterQuestoes = "convenios/finalizarAnalisesPecasObrigatorias?idPca=" + this.gestaoPcaService.getPCA().id + "&cdAnalise=" + pcdAnalise;
        return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
    }

    //- Relação de convênios celebrados no exercício:

    public listarConvenioCelebrado(): Observable<any> {
        this.urlObterQuestoes = "convenios/listarConveniosCelebrados?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.getJSON(this.urlObterQuestoes);
    }

    public downloadTemplateCargaMassa(pCodTemplate) {
        let path = "convenios/downloadTemplateCargaEmMassa/" + pCodTemplate;
        let filename = "";
        if (parseFloat(pCodTemplate) == 1) {
            filename = "templateRelacaoConveniosXls"
        }
        else {
            filename = "templateComunicacaoInadimplenciasXls"

        }

        var headers = new HttpHeaders();
        headers.append('responseType', 'arraybuffer');
        this.utilService.getJSON(path)
            .subscribe(data => {
                let contentType = "data:" + data.mimeType + ";base64";

                let byteCharacters = atob(data.decodedFile);

                let byteNumbers = new Array(byteCharacters.length);
                for (var i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }

                var byteArray = new Uint8Array(byteNumbers);
                let file = new Blob([byteArray], { type: contentType });
                saveAs(file, filename + ".xlsx");
            },
                error => console.log("Error downloading the file. error: " + error));
    }

    public deletarConvenioRelacaoCelebrado(pIdRelacao) {
        let urlObtencaoDados: string = "convenios/deletarRelacaoConveniosCelebrados?idRelacao=" + pIdRelacao;
        return this.utilService.deleteJSON(urlObtencaoDados);
    }

    public deletarRelacaoConveniosCelebradosLista(jsonList, exclusaoTotal, idModuloAnalise): Observable<any> {
        this.urlObterQuestoes = "convenios/deletarRelacaoConveniosCelebradosLista?exclusaoTotal="+ exclusaoTotal + "&idModuloAnalise=" + idModuloAnalise;
        return this.utilService.postJSON(this.urlObterQuestoes, jsonList);
      }

    public salvarConvenioRelacaoCelebrado(jsonObjeto): Observable<any> {
        this.urlObterQuestoes = "convenios/salvarRelacaoConveniosCelebrados?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
    }

    public finalizarConvenioRelacaoCelebrado(jsonObjeto): Observable<any> {
        this.urlObterQuestoes = "convenios/finalizarRelacaoConveniosCelebrados?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
    }

    public cargaMassaConvenioRelacaoCelebrado(event): Observable<any> {
        this.urlObterQuestoes = "convenios/importarRelacaoConveniosCelebrados?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.postJSON(this.urlObterQuestoes, event);
    }

    // - Comunicação das inadimplências à autoridade administrativa competente:
    public listarConvenioComunicacaoInadimplencia(): Observable<any> {
        this.urlObterQuestoes = "convenios/listarComunicacaoInadimplencias?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.getJSON(this.urlObterQuestoes);
    }

    public deletarConvenioComunicacaoInadimplencia(pIdComunicacaoInadimplencias) {
        let urlObtencaoDados: string = "convenios/deletarComunicacaoInadimplencias?idComunicacaoInadimplencias=" + pIdComunicacaoInadimplencias;
        return this.utilService.deleteJSON(urlObtencaoDados);
    }

    public deletarConvenioComunicacaoInadimplenciaLista(jsonList, exclusaoTotal, idModuloAnalise): Observable<any> {
        this.urlObterQuestoes = "convenios/deletarComunicacaoInadimplenciasLista?exclusaoTotal="+ exclusaoTotal + "&idModuloAnalise=" + idModuloAnalise;
        return this.utilService.postJSON(this.urlObterQuestoes, jsonList);
    }

    public salvarConvenioComunicacaoInadimplencia(jsonObjeto): Observable<any> {
        this.urlObterQuestoes = "convenios/salvarComunicacaoInadimplencias?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
    }

    public cargaMassaConvenioComunicacaoInadimplencia(event): Observable<any> {
        return this.fileService.cargaRelacaoInadimplencias(event);
    }

    public finalizarConvenioComunicacaoInadimplencia(jsonObjeto): Observable<any> {
        this.urlObterQuestoes = "convenios/finalizarComunicacaoInadimplencias?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
    }

    //  **
    //  **  ANALISTA 8===o
    //  **

    public obterPreviewCertificado(): Observable<any> {
        this.urlObterQuestoes = "analiseConvenios/obterCertificado?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.getJSON(this.urlObterQuestoes);
    }

    //Semáforo 
    public obterResumoAnalise(): Observable<any> {
        this.urlObterQuestoes = "analiseConvenios?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.getJSON(this.urlObterQuestoes);
    }

    //submeter de todas as regras
    public submeterAnalise(dados, cdAnalise) {
        let urlObtencaoDados = "analiseConvenios/encerrarAnalise?idPca=" + this.gestaoPcaService.getPCA().id + "&cdAnalise=" + cdAnalise;
        return this.utilService.postJSON(urlObtencaoDados, dados);
    }

    //Regra 1
    public obterDadosResumoRelatorioInspecao() {
        let urlObtencaoDados = "analiseConvenios/obterRelatoriosDeInspecao?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.getJSON(urlObtencaoDados);
    }

    public salvarDadosResumoRelatorioInspecao(dados, cdAnalise) {
        let urlObtencaoDados = "analiseConvenios/salvarRelatoriosDeInspecao?idPca=" + this.gestaoPcaService.getPCA().id + "&cdAnalise=" + cdAnalise;
        return this.utilService.postJSON(urlObtencaoDados, dados);
    }

    public obterArquivoResumoRelatorioInspecao(idDoc) {
        this.fileService.downloadArquivoResumoRelatorioInspecao(idDoc);
    }

    //Regra 2
    /*public obterArquivoRelatorioAuditoria() {
        this.fileService.downloadArquivoRelatorioAuditoria(this.gestaoPcaService.getPCA().id);
    }*/

    public obterRelatoriosDeAuditoria() {
        let urlObtencaoDados = "analiseConvenios/obterRelatoriosDeAuditoria?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.getJSON(urlObtencaoDados);
    }

    public salvarRelatoriosDeAuditoria(dados, cdAnalise) {
        let urlObtencaoDados = "analiseConvenios/salvarRelatoriosDeAuditoria?idPca=" + this.gestaoPcaService.getPCA().id + "&cdAnalise=" + cdAnalise;
        return this.utilService.postJSON(urlObtencaoDados, dados);
    }

    public submeterRelatoriosDeAuditoria(dados, cdAnalise) {
        let urlObtencaoDados = "analiseConvenios/submeterRelatoriosDeAuditoria?idPca=" + this.gestaoPcaService.getPCA().id + "&cdAnalise=" + cdAnalise;
        return this.utilService.postJSON(urlObtencaoDados, dados);
    }

    public downloadArquivoRelatoriosDeAuditoria(idArquivo) {
        this.fileService.baixarArquivo(idArquivo);
    }

    // public obterArquivoResumoRelatorioInspecao(idDoc) {
    //     this.fileService.downloadArquivoResumoRelatorioInspecao(idDoc);
    // }

    //Regra 5
    public obterDesconformidadePublicacao() {
        let urlObtencaoDados = "analiseConvenios/obterAnaliseDesconformidadePublicacao?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.getJSON(urlObtencaoDados);
    }

    public salvarDesconformidadePublicacao(dados) {
        let urlObtencaoDados = "analiseConvenios/salvarDesconformidadePublicacao?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.postJSON(urlObtencaoDados, dados);
    }

    public finalizarDesconformidadePublicacao(dados) {
        let urlObtencaoDados = "analiseConvenios/submeterDesconformidadePublicacao?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.postJSON(urlObtencaoDados, dados);
    }

    //Regra 6
    public obterCelebracaoInadimplente() {
        let urlObtencaoDados = "analiseConvenios/obterAnalisesCelebracaoInadimplente?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.getJSON(urlObtencaoDados);
    }

    public salvarCelebracaoInadimplente(dados) {
        let urlObtencaoDados = "analiseConvenios/salvarCelebracaoInadimplente?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.postJSON(urlObtencaoDados, dados);
    }

    public finalizarCelebracaoInadimplente(dados) {
        let urlObtencaoDados = "analiseConvenios/submeterCelebracaoInadimplente?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.postJSON(urlObtencaoDados, dados);
    }

    //Regra 7
    public obterParcelaUnica() {
        let urlObtencaoDados = "analiseConvenios/obterAnaliseParcelaUnica?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.getJSON(urlObtencaoDados);
    }

    public salvarParcelaUnica(dados) {
        let urlObtencaoDados = "analiseConvenios/salvarAnaliseParcelaUnica?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.postJSON(urlObtencaoDados, dados);
    }

    public finalizarParcelaUnica(dados) {
        let urlObtencaoDados = "analiseConvenios/submeterAnaliseParcelaUnica?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.postJSON(urlObtencaoDados, dados);
    }

    //Regra 8
    public obterApresentacaoFPrazo() {
        let urlObtencaoDados = "analiseConvenios/obterAnaliseApresentacaoForaPrazo?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.getJSON(urlObtencaoDados);
    }

    public salvarApresentacaoFPrazo(dados) {
        let urlObtencaoDados = "analiseConvenios/salvarAnaliseApresentacaoForaPrazo?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.postJSON(urlObtencaoDados, dados);
    }

    public finalizarApresentacaoFPrazo(dados) {
        let urlObtencaoDados = "analiseConvenios/submeterAnaliseApresentacaoForaPrazo?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.postJSON(urlObtencaoDados, dados);
    }

    //Regra 9
    public obterSaldoRemanescente() {
        let urlObtencaoDados = "analiseConvenios/obterAnaliseSaldosRemanescentes?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.getJSON(urlObtencaoDados);
    }

    public salvarSaldoRemanescente(dados) {
        let urlObtencaoDados = "analiseConvenios/salvarAnaliseSaldosRemanescentes?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.postJSON(urlObtencaoDados, dados);
    }

    public finalizarSaldoRemanescente(dados) {
        let urlObtencaoDados = "analiseConvenios/submeterAnaliseSaldosRemanescentes?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.postJSON(urlObtencaoDados, dados);
    }

    //Regra 10
    public obterPrestacaoSuperior() {
        let urlObtencaoDados = "analiseConvenios/obterAnalisePrestacaoSuperior?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.getJSON(urlObtencaoDados);
    }

    public salvarPrestacaoSuperior(dados) {
        let urlObtencaoDados = "analiseConvenios/salvarPrestacaoSuperior?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.postJSON(urlObtencaoDados, dados);
    }

    public finalizarPrestacaoSuperior(dados) {
        let urlObtencaoDados = "analiseConvenios/submeterPrestacaoSuperior?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.postJSON(urlObtencaoDados, dados);
    }

    //Regra 11
    public obterSaldosADevolver() {
        let urlObtencaoDados = "analiseConvenios/obterAnaliseSaldosADevolver?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.getJSON(urlObtencaoDados);
    }

    public salvarSaldosADevolver(dados) {
        let urlObtencaoDados = "analiseConvenios/salvarAnaliseSaldosADevolver?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.postJSON(urlObtencaoDados, dados);
    }

    public finalizarSaldosADevolver(dados) {
        let urlObtencaoDados = "analiseConvenios/submeterAnaliseSaldosADevolver?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.postJSON(urlObtencaoDados, dados);
    }

    //Regra 12
    public obterPrestacaoForaPrazo() {
        let urlObtencaoDados = "analiseConvenios/obterAnalisePrestacaoForaPrazo?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.getJSON(urlObtencaoDados);
    }

    public salvarPrestacaoForaPrazo(dados) {
        let urlObtencaoDados = "analiseConvenios/salvarAnalisePrestacaoForaPrazo?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.postJSON(urlObtencaoDados, dados);
    }

    public finalizarPrestacaoForaPrazo(dados) {
        let urlObtencaoDados = "analiseConvenios/submeterAnalisePrestacaoForaPrazo?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.postJSON(urlObtencaoDados, dados);
    }

    //Regra 13
    public obterCelebracaoAtraso() {
        let urlObtencaoDados = "analiseConvenios/obterAnaliseCelebracaoAtraso?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.getJSON(urlObtencaoDados);
    }

    public salvarCelebracaoAtraso(dados) {
        let urlObtencaoDados = "analiseConvenios/salvarAnaliseCelebracaoAtraso?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.postJSON(urlObtencaoDados, dados);
    }

    public finalizarCelebracaoAtraso(dados) {
        let urlObtencaoDados = "analiseConvenios/submeterAnaliseCelebracaoAtraso?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.postJSON(urlObtencaoDados, dados);
    }

    //Regra 14
    public obterRegistroIncorreto() {
        let urlObtencaoDados = "analiseConvenios/obterAnaliseRegistroIncorreto?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.getJSON(urlObtencaoDados);
    }

    public salvarRegistroIncorreto(dados) {
        let urlObtencaoDados = "analiseConvenios/salvarAnaliseRegistroIncorreto?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.postJSON(urlObtencaoDados, dados);
    }

    public finalizarRegistroIncorreto(dados) {
        let urlObtencaoDados = "analiseConvenios/submeterAnaliseRegistroIncorreto?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.postJSON(urlObtencaoDados, dados);
    }

    //Regra 15
    public obterConveniosInadimplencia() {
        let urlObtencaoDados = "analiseConvenios/obterAnaliseInstrumentoCongeneres?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.getJSON(urlObtencaoDados);
    }

    public salvarConveniosInadimplencia(dados) {
        let urlObtencaoDados = "analiseConvenios/salvarAnaliseInstrumentoCongeneres?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.postJSON(urlObtencaoDados, dados);
    }

    public finalizarConveniosInadimplencia(dados) {
        let urlObtencaoDados = "analiseConvenios/submeterAnaliseInstrumentoCongeneres?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.postJSON(urlObtencaoDados, dados);
    }

    //Regra 16
    public obterComunicacaoInadimplencia() {
        let urlObtencaoDados = "analiseConvenios/obterAnaliseComunicacaoInadimplencia?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.getJSON(urlObtencaoDados);
    }

    public salvarComunicacaoInadimplencia(dados) {
        let urlObtencaoDados = "analiseConvenios/salvarAnaliseComunicacaoInadimplencia?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.postJSON(urlObtencaoDados, dados);
    }

    public finalizarComunicacaoInadimplencia(dados) {
        let urlObtencaoDados = "analiseConvenios/submeterAnaliseComunicacaoInadimplencia?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.postJSON(urlObtencaoDados, dados);
    }

    //Regra 17
    public obterEmpenhoAssinatura() {
        let urlObtencaoDados = "analiseConvenios/obterAnaliseNotaAnteriorAssinatura?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.getJSON(urlObtencaoDados);
    }

    public salvarEmpenhoAssinatura(dados) {
        let urlObtencaoDados = "analiseConvenios/salvarNotaAnteriorAssinatura?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.postJSON(urlObtencaoDados, dados);
    }

    public finalizarEmpenhoAssinatura(dados) {
        let urlObtencaoDados = "analiseConvenios/submeterNotaAnteriorAssinatura?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.postJSON(urlObtencaoDados, dados);
    }

    //Regra 18
    public obterEmpenhoPublicacao() {
        let urlObtencaoDados = "analiseConvenios/obterAnaliseNotaAnteriorPublicacao?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.getJSON(urlObtencaoDados);
    }

    public salvarEmpenhoPublicacao(dados) {
        let urlObtencaoDados = "analiseConvenios/salvarNotaAnteriorPublicacao?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.postJSON(urlObtencaoDados, dados);
    }

    public finalizarEmpenhoPublicacao(dados) {
        let urlObtencaoDados = "analiseConvenios/submeterNotaAnteriorPublicacao?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.postJSON(urlObtencaoDados, dados);
    }

    //Regra 19
    public obterEmpenhoVigencia() {
        let urlObtencaoDados = "analiseConvenios/obterAnaliseNotaPosteriorVigencia?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.getJSON(urlObtencaoDados);
    }

    public salvarEmpenhoVigencia(dados) {
        let urlObtencaoDados = "analiseConvenios/salvarNotaPosteriorVigencia?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.postJSON(urlObtencaoDados, dados);
    }

    public finalizarEmpenhoVigencia(dados) {
        let urlObtencaoDados = "analiseConvenios/submeterNotaPosteriorVigencia?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.postJSON(urlObtencaoDados, dados);
    }

    //Regra 20
    public obterMedidasForaPrazo() {
        let urlObtencaoDados = "analiseConvenios/obterAnaliseMedidaAdmForaPrazo?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.getJSON(urlObtencaoDados);
    }

    public salvarMedidasForaPrazo(dados) {
        let urlObtencaoDados = "analiseConvenios/salvarMedidaAdmForaPrazo?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.postJSON(urlObtencaoDados, dados);
    }

    public finalizarMedidasForaPrazo(dados) {
        let urlObtencaoDados = "analiseConvenios/submeterMedidaAdmForaPrazo?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.postJSON(urlObtencaoDados, dados);
    }
}



// WEBPACK FOOTER //
// ./src/providers/convenio-service.ts